import React from "react";

export const SortingContext = React.createContext(false);


// WEBPACK FOOTER //
// ./src/components/SortingContext.js